import Vue from 'vue'
import App from './App.vue'
import "tailwindcss/tailwind.css";
import router from './router'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui';
import './element-variables.scss';
import './assets/css/common.scss'
import 'animate.css';
import i18n from "@/locale";

Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(ElementUI);
new Vue({
    beforeCreate() {
        this.__proto__.$bus = this;
        // Vue.prototype.$bus = this
    },
    i18n,
    router: router,
    render: h => h(App),

}).$mount('#app')
